import React from "react";
import { Box, Flex } from "@costar/theme-ui";
var backgroundGradientSx = { background: "linear-gradient(0deg, rgba(238, 238, 238, 0) 0%, #d8d8d8 100%)" };
export var FooterStrip = function (props) {
    return (React.createElement(Box, { backgroundColor: "neutral.lighter", width: "100%", position: "relative", zIndex: 0, bottom: 0, left: 0, height: 55, "automation-id": "footer-strip" },
        React.createElement(Box, { height: "5px", sx: backgroundGradientSx }),
        React.createElement(Flex, { flexDirection: "row", pr: "20px", fontFamily: "Helvetica", height: 45, justifyContent: "center", alignItems: "center" }, props.children)));
};
//# sourceMappingURL=FooterStrip.js.map